import styled from '@emotion/styled'
import { space, SpaceProps } from 'styled-system'

export type SectionProps = {
  type: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'nesting-only'
}

function getBackgroundColor(props: SectionProps) {
  switch (props.type) {
    case 'primary':
      return 'var(--White)'
    case 'secondary':
      return 'var(--White96)'
    case 'tertiary':
      return 'var(--White)'
    case 'quaternary':
      return 'var(--White98)'
    case 'nesting-only':
      return 'var(--Transparent)'
  }
}
function getBorderColor(props: SectionProps) {
  switch (props.type) {
    case 'primary':
      return 'none'
    case 'secondary':
      return 'none'
    case 'tertiary':
      return '1px Solid var(--White95)'
    case 'quaternary':
      return 'none'
    case 'nesting-only':
      return 'none'
  }
}

export const Section = styled.div<SectionProps & SpaceProps>`
  border: ${props => getBorderColor(props)};
  border-radius: 4px;
  background-color: ${props => getBackgroundColor(props)};
  ${space}
`
